module.exports = __webpack_public_path__ + "static/media/acquisition_selected.028323b2.svg";